import { UserManager } from "oidc-client-ts";
import { createOidcSettings } from "@optimyl/auth";
import { getConfig } from "../config";

export const EMPLOYER_CLIENT_ID = "employer-intake-spa";

let _instance: UserManager | null = null;

/** This tab's one user manager. Made on first use, after config has loaded; never while sign-in is turned off. */
export function getUserManager(): UserManager {
  if (!_instance) {
    _instance = new UserManager(createOidcSettings({ identityUrl: getConfig().IDENTITY_URL, clientId: EMPLOYER_CLIENT_ID }));
  }
  return _instance;
}
